// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07cbba7b","455":"8b6d8279","977":"1f34437d"}[chunkId] + ".chunk.js";
};